import { Injectable } from '@angular/core';
import {ConfigurationDataProvider} from '../configuration-data-provider';
import {SharedDataProvider} from '../shared-data-provider';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Bin} from '../dto/bin';

@Injectable()
export class BinProvider {

  headers = new HttpHeaders({
      'Content-Type': 'application/json'
  });

  private getAuthHeader() : any {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'X-pePeLo-Auth': JSON.stringify(this.shared.getTokenAuthData())
    });
    return headers;
  }

  constructor(public http: HttpClient, private config : ConfigurationDataProvider, private shared: SharedDataProvider) {
  }

  /**
   * List all bins which belong to loggedin user.
   */
  public list() {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.post(this.config.binURL+"list", JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public save(bin : Bin) {
    console.log('Push bin to insert method of service.');
    bin.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(bin));
    return this.http.post(this.config.binURL+"new", JSON.stringify(bin), {headers: this.headers});
  }

  public update(bin : Bin) {
    console.log('Push bin to update method of service.');
    bin.credentials = this.shared.getTokenAuthData();
    console.log(JSON.stringify(bin));
    return this.http.put(this.config.binURL+"id/"+bin.id, JSON.stringify(bin), {headers: this.headers});
  }

  public qryBin(id : number) {
    return this.http.post(this.config.binURL+"id/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public qryBinBarcode(barcode : string) {
    return this.http.post(this.config.binURL+"barcode/"+barcode,
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public delete(id : number) {
    console.log('Delete bin '+ id);
    return this.http.post(this.config.binURL+"del/"+id, 
    JSON.stringify(this.shared.getTokenAuthData()), {headers: this.headers});
  }

  public move(params : any) {
    console.log('Move bin '+ params);
    params.credentials = this.shared.getTokenAuthData();
    return this.http.post(this.config.binURL+"move", 
    JSON.stringify(params), {headers: this.headers});
  }

  public listBinsOnLocationId(locationId : number) {
    console.log(JSON.stringify(this.shared.getTokenAuthData()));
    return this.http.get(this.config.binURL+"location/"+locationId, {headers: this.getAuthHeader()});
  }
}



// WEBPACK FOOTER //
// ./src/providers/bin/bin.ts